import { render, staticRenderFns } from "./drag.vue?vue&type=template&id=2c62024c"
import script from "./drag.vue?vue&type=script&lang=js"
export * from "./drag.vue?vue&type=script&lang=js"
import style0 from "./drag.vue?vue&type=style&index=0&id=2c62024c&prod&lang=scss&rel=stylesheet%2Fsass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports